<template>
  <div class="help-block">
    <h2 class="help-block__title">
      Как стать партнером
    </h2>
    <div class="help-block-items">
      <HelpBlockItem v-for="item in 4" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'HelpBlock',
  props: ['result'],
}
</script>

<style lang="scss" scoped>
.help-block {
  margin-bottom: 109px;
  @include tablet{
    margin-bottom: 66px;
  }
  &__title{
    margin-bottom: 44px;
    @include tablet{
      margin-bottom: 57px;
    }
  }
}
.help-block-items{
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-column-gap: 30px;
  @include tablet{
    grid-template-columns: repeat(2, 1fr);
    grid-row-gap: 47px;
  }
  @include mobile{
    grid-template-columns: 1fr;
    grid-row-gap: 15px;
  }
}
</style>